<template>
    <div>
        <loading v-if="showLoading"></loading>
        <account-status :account_status="account_status"></account-status> 
        <MonthSalesStatistics @show_account_status="show_account_status"></MonthSalesStatistics>

        <div class="widget has-shadow">

            <div class="widget-header bordered d-flex align-items-center">
                <h2>آخرین سفارشات ثبت شده</h2>
            </div>

            <div class="widget-body">
                 <order-table v-bind:orderList="orderList" :page="page"></order-table>
             </div>
            
        </div> 
    </div>
</template>

<script>
import MonthSalesStatistics from './MonthSalesStatistics.vue';
import OrderTable from './OrderTable';
import myMinix from '../myMixin';
export default {
    components:{MonthSalesStatistics,OrderTable},
    mixins:[myMinix],
    data(){
        return {
            account_status:'active',
            showLoading:false,
            page:1,
            orderList:{data:[]}
        }
    },
    mounted(){
       this.account_status=localStorage.getItem('account_status');
       this.getOrders(1);
    },
    methods:{
        show_account_status:function()
        {
           this.account_status=localStorage.getItem('account_status');
        },
        getOrders:function(page=1){
            this.page=page;
            this.showLoading=true;
            const url=this.$siteUrl+'/api/seller/orders?page='+page;
            this.axios.get(url,this.setHeader()).then(response=>{
                this.showLoading=false;
                const result=this.setAccountStatus(response.data);
                if(result)
                {
                    this.orderList=response.data;
                }
            }).catch((error)=>{
                this.showLoading=false;
                this.setCatch(error);
            });
        }
    }
}
</script>

<style>

</style>